export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"Fincs（フィンクス）は、それぞれのテーマを専門とする厳選された講師がレベル、目的別の講座をオンラインで提供する学習プラットフォームです。"},{"property":"og:url","content":"https://fincs.jp"},{"property":"og:title","content":"Fincs(フィンクス) - 最前線、最高鮮度の、スキルを学ぶ。"},{"property":"og:description","content":"Fincs（フィンクス）は、それぞれのテーマを専門とする厳選された講師がレベル、目的別の講座をオンラインで提供する学習プラットフォームです。"},{"property":"og:image","content":"https://fincs-web-api-prd.s3.ap-northeast-1.amazonaws.com/ogp/fincsogp.jpg"},{"property":"og:type","content":"website"},{"property":"og:locale","content":"ja_JP"},{"property":"og:site_name","content":"Fincs"},{"name":"theme-color","content":"black"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=auto"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","type":"image/png","href":"/apple-touch-icon.png","sizes":"180x180"},{"rel":"preconnect","href":"https://api.fincs.jp"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://www.google-analytics.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://www.googletagmanager.com","crossorigin":"anonymous"}],"style":[],"script":[{"src":"https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js","async":true},{"innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-K8WT5LWQ');"}],"noscript":[{"innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-K8WT5LWQ\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"htmlAttrs":{"lang":"ja"},"title":"Fincs(フィンクス) - 最前線、最高鮮度の、スキルを学ぶ。"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true